<template>
  <div class="container">
    <div class="menu">
      <Header />
      <div class="sub-header" v-if="!!$slots['header']">
        <slot name="header" />
      </div>
    </div>
    <div class="content" :class="{
      'content--smallheader': (!!$slots['header'] && smallHeader),
      'content--mediumheader': (!!$slots['header'] && mediumHeader),
      'content--noheader': !!!$slots['header']
    }">
      <slot />
    </div>
  </div>
</template>

<script>
import Header from "./Header";

export default {
  components: {
    Header
  },
  props: {
    smallHeader: {
      type: Boolean,
      default: false
    },
    mediumHeader: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;

  .menu {
    position: fixed;
    background: var(--color-white);
    width: 100%;
    z-index: 20;
  }

  .sub-header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    max-width: 1280px;
    padding: 10px 25px;
    margin: 0 auto;
    background: var(--color-white);
    border-bottom: 1px solid var(--color-dark-blue);
  }

  .content {
    max-width: 1280px;
    min-height: calc(100vh - 185px);
    margin: 0 auto;
    padding-top: 185px;
    overflow: hidden;

    &.content--smallheader {
      min-height: calc(100vh - 185px);
      padding-top: 185px;
    }

    &.content--mediumheader {
      min-height: calc(100vh - 222px);
      padding-top: 222px;
    }

    &.content--noheader {
      min-height: calc(100vh - 120px);
      padding-top: 120px;
    }
  }
}

@media (max-width: 900px) {
  .container {
    .content {
      min-height: calc(100vh - 180px);
      padding-top: 180px;

      &.content--smallheader {
        min-height: calc(100vh - 200px);
        padding-top: 200px;
      }

      &.content--mediumheader {
        min-height: calc(100vh - 230px);
        padding-top: 230px;
      }
    }
  }
}
</style>
